<template>
  <el-dialog
    title="导出统计"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form
        :inline="true"
        label-position="left"
        class="demo-form-inline"
        :model="form"
        :rules="rules"
        ref="demoref"
      >
        <el-form-item
          label="导出时间统计"
          prop="valueTime"
          v-if="typeExport == 1"
        >
          <el-date-picker
            v-model="form.valueTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="导出时间统计"
          prop="valueTime"
          v-if="typeExport == 2"
        >
          <el-date-picker
            v-model="form.valueTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="typeExport == 2" label="数据来源">
          <el-select
            filterable
            placeholder="请选择数据来源"
            clearable
            multiple
            v-model="form.reportSourceList"
          >
            <el-option
              v-for="item in reportSourceListOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button
        type="primary"
        @click="addOrUpdateFun()"
        :loading="exportLoading"
        >导 出</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import {
  reportTaskback,
  reportTaskLeftHandleTotalExp,
  infiniteTotalExp
} from "@/api/task.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    pictureList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    typeExport: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      form: {
        valueTime: null,
        reportSourceList: []
      },
      rules: {
        valueTime: [
          { required: true, message: "请选择导出时间统计", trigger: "change" }
        ]
      },
      reportSourceListOptions: [
        {
          label: "网格上报",
          value: "wg"
        },
        {
          label: "居民上报未转网格",
          value: "jm"
        },
        {
          label: "居民转网格",
          value: "jmToWg"
        },
        {
          label: "企业上报",
          value: "qy"
        }
      ],
      exportLoading: false
    };
  },
  mounted() {
    console.log(this.typeExport, "this.typeExport");
  },
  methods: {
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    addOrUpdateFun() {
      this.$refs.demoref.validate(async valid => {
        if (valid) {
          this.exportLoading = true;
          if (this.typeExport == 1) {
            let res = await infiniteTotalExp({
              timeStr: this.form.valueTime[0],
              timeEndStr: this.form.valueTime[1]
            });
            if (res.status == 200) {
              this.exportLoading = false;
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `${this.form.valueTime[0]}到${this.form.valueTime[1]}统计数导出.xlsx`
              );
              document.body.appendChild(link);
              link.click();
              this.$emit("update:dialogVisible", false);
            }
          } else {
            let res = await reportTaskLeftHandleTotalExp({
              timeStr: this.form.valueTime[0],
              timeEndStr: this.form.valueTime[1],
              reportSourceList: this.form.reportSourceList || []
            });
            if (res.status == 200) {
              this.exportLoading = false;
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `${this.form.valueTime[0]}到${this.form.valueTime[1]}关芯智巡问题上报数据统计.xlsx`
              );
              document.body.appendChild(link);
              link.click();
              this.$emit("update:dialogVisible", false);
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 10px 20px;
}

/deep/.el-input {
  width: auto !important;
}
/deep/.el-dialog {
  margin-top: 16vh !important;
}
.flex {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/reportproblemAnalysis/components/exportDialog.vue